import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/styles/index.less' // global css
import '@/assets/icons' // svg icons

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import SlideVerify from 'vue-monoplasty-slide-verify';

import plugins from './plugins' // plugins
// 长文本预览组件
import Ellipsis from '@/components/Ellipsis'
// 分页组件
import Pagination from "@/components/Pagination";
// 富文本组件
import Editor from "@/components/Editor"
// 搜索栏组件
import SearchBar from "@/components/SearchBar"
// 登录框组件
import Login from "@/components/Login"
// 附件上传组件
import FileUpload from "@/components/FileUpload"

import { deepClone } from '@/utils';

Vue.prototype.deepClone = deepClone

Vue.component('Ellipsis', Ellipsis);
Vue.component('Pagination', Pagination);
Vue.component('Editor', Editor);
Vue.component('SearchBar', SearchBar);
Vue.component('Login', Login);
Vue.component('FileUpload', FileUpload);
Vue.use(ElementUI, { size: 'medium' });
Vue.use(SlideVerify);
Vue.use(plugins)

Vue.config.productionTip = false

export const bus = new Vue();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
